import React, { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import Form from "react-bootstrap/Form";
import { useSortAndFilter } from "../contexts/SortAndFilterContext";
import { messages } from "./messages";
import { Container } from "./styles";

export const ShowOnlyMasterLinesCheck = (): JSX.Element => {
  const intl = useIntl();
  const sortAndFilterContext = useSortAndFilter();

  const isSelected = useMemo(() =>
    sortAndFilterContext.isShowOnlyMasterLinesSelected(),
    [sortAndFilterContext]
  );

  const handleOnChange = useCallback(() => {
    sortAndFilterContext.markShowOnlyMasterLines(!isSelected);
  }, [isSelected, sortAndFilterContext]);

  return (
    <Container>
      <Form.Check
        inline
        label={intl.formatMessage(messages.showOnlyMasterLines)}
        name="showOnlyMasterLines"
        id="showOnlyMasterLines"
        onChange={handleOnChange}
        checked={isSelected}
      />
    </Container>
  );
};
